import React, { useEffect, useState } from 'react'
import { Area } from 'components/Charts_Area'
import Chart from 'components/Charts_Chart'
import Key from 'components/Charts_Key'
import './styles.scss'
import { nF } from 'components/Charts_Assets'

const ageVaccGroupsCases = [
  '10-19',
  '20-29',
  '30-39',
  '40-49',
  '50-59',
  '60-69',
  '70-79',
  '80+'
]
const ageGroupsCases = [
  '0-19',
  '20-29',
  '30-39',
  '40-49',
  '50-59',
  '60-69',
  '70-79',
  '80+'
]
const ageGroupsHosp = [
  '0-19',
  '20-29',
  '30-39',
  '40-49',
  '50-59',
  '60-69',
  '70-79',
  '80+'
]
const ageGroupsTests = [
  '0-3',
  '4-11',
  '12-15',
  '16-19',
  '20-39',
  '40-64',
  '65-79',
  '80+'
]

const formatSwissDate = (a: string) =>
  new Date(a).toLocaleDateString('ch-DE', {
    day: 'numeric',
    month: 'numeric',
    year: '2-digit'
  })
type testAgeDataType = {
  week: number
  year: number
  age: string
  [key: string]: number | string
}[]
export const Ages = ({}: {}) => {
  const [testAgeData, setTestAgeData] = useState<testAgeDataType | undefined>()
  const [ageData, setAgeData] = useState<testAgeDataType | undefined>()
  const [ageHospData, setAgeHospData] = useState<testAgeDataType | undefined>()
  // const [ageVaccDataBAG, setAgeVaccBAGData] = useState<
  //   testAgeDataType | undefined
  // >()

  const [maxValues, setMaxValues] = useState({
    cases: 0,
    vacc: 0,
    testsdone: 0,
    testspositive: 0,
    hosp: 0
  })

  const [ageVaccData, setAgeVaccData] = useState<testAgeDataType | undefined>()
  const getMaxValue = (
    data: testAgeDataType,
    group: string[],
    prop: string
  ) => {
    const maxYear = Math.max(...data.map(m => +m.year))
    const lastyearData = data.filter(f => f.year === maxYear)
    const maxWeekInMaxYear = Math.max(...lastyearData.map(m => +m.week))
    const lastWeekData = lastyearData.filter(f => f.week === maxWeekInMaxYear)
    if (!lastWeekData) return

    const lastValues = group
      .map(m => {
        const last = lastWeekData.find(f => f.age === m)
        if (!last) return 0
        return last[prop]
      })
      .map(Number)

    return Math.ceil(Math.max(...lastValues) / 50) * 50
  }

  useEffect(() => {
    fetch(
      'https://ta-interaktiv.storage.googleapis.com/corona-dashboard/ZH-Ages.json'
    )
      .then(response => response.json())
      .then(data => {
        setAgeData(data as testAgeDataType)
      })
    fetch(
      'https://ta-interaktiv.storage.googleapis.com/corona-dashboard/ZH-AgeTests.json'
    )
      .then(response => response.json())
      .then(data => {
        setTestAgeData(data as testAgeDataType)
      })

    // fetch(
    //   'https://ta-interaktiv.storage.googleapis.com/corona-dashboard/ZH-AgeVaccBAG.json'
    // )
    //   .then(response => response.json())
    //   .then(data => {
    //     console.log(data)
    //     setAgeVaccBAGData(data as testAgeDataType)
    //   })
    fetch(
      'https://storage.googleapis.com/ta-interaktiv/corona-dashboard/ZH-AgeVacc.json'
    )
      .then(response => response.json())
      .then(data => {
        console.log(data)
        setAgeVaccData(data as testAgeDataType)
      })
    fetch(
      'https://ta-interaktiv.storage.googleapis.com/corona-dashboard/ZH-AgeHosp.json'
    )
      .then(response => response.json())
      .then(data => {
        setAgeHospData(data as testAgeDataType)
      })
  }, [])
  return (
    <>
      <div className='ui  container'>
        <div className='columnwrapper'>
          <div className='left'>
            <div className='Ages'>
              {ageData && (
                <Chart
                  title='7-Tages-Inzidenz im Kt. Zürich'
                  sub={`Anzahl Fälle pro 100'000 Personen in einer Woche, bis zum ${formatSwissDate(
                    ageData[ageData.length - 1].d
                  )}`}
                  source={
                    <>
                      Quelle:{' '}
                      <a
                        href='https://raw.githubusercontent.com/openZH/covid_19/master/fallzahlen_kanton_alter_geschlecht_csv/COVID19_Fallzahlen_Kanton_ZH_Altersgruppen_geschlecht.csv'
                        target='_blank'
                        rel='noreferrer'
                      >
                        Gesundheitsdirektion Kanton Zürich
                      </a>
                    </>
                  }
                >
                  <div className='agekey'>
                    <div className='left'>Altersgruppe</div>
                    <div className='middle' />
                    <div className='value'>aktuell</div>
                  </div>
                  {ageGroupsCases.map((m, i) => {
                    const od = ageData.filter(f => f.age === m)
                    const ad = od.map(m => ({ d: m.d, v: m.casesInz }))
                    const max =
                      getMaxValue(ageData, ageGroupsCases, 'casesInz') || 1

                    return (
                      <div className='agegroup' key={'agegroup_cases_' + i}>
                        <div className='age'>{m}</div>
                        <div className='barcontainer'>
                          <Area
                            data={[ad]}
                            yDomain={[max * 9, 0]}
                            yTicks={{
                              lines: [0],
                              text: []
                            }}
                            height={60}
                            xTicks={{
                              text: [
                                '2020-01-01',
                                '2021-01-01',
                                '2021-07-01',
                                '2021-12-01'
                              ],
                              lines: [
                                '2020-01-01',
                                '2021-01-01',
                                '2021-07-01',
                                '2021-12-01'
                              ]
                            }}
                            className='casesInz'
                          />
                        </div>
                        <div className='value'>
                          {Math.round(od[od.length - 1].casesInz)}
                        </div>
                      </div>
                    )
                  })}
                </Chart>
              )}
            </div>
          </div>

          <div className='right'>
            <div className='Ages'>
              {ageHospData && (
                <Chart
                  title='Spitaleintritte pro Woche im Kt. Zürich'
                  sub={`bis zum ${formatSwissDate(
                    ageHospData[ageHospData.length - 1].d
                  )}`}
                  source={
                    <>
                      Quelle:{' '}
                      <a
                        href='https://www.covid19.admin.ch/de/overview'
                        target='_blank'
                        rel='noreferrer'
                      >
                        BAG
                      </a>
                    </>
                  }
                >
                  <div className='agekey'>
                    <div className='left'>Altersgruppe</div>
                    <div className='middle' />
                    <div className='value'>aktuell</div>
                  </div>
                  {ageGroupsHosp.map((m, i) => {
                    const od = ageHospData.filter(f => f.age === m)
                    const ad = od.map(m => ({ d: m.d, v: m.v }))

                    const max =
                      getMaxValue(
                        ageHospData
                          .filter(f => typeof f !== 'string')
                          .map(m => {
                            m.year = +m.year
                            m.week = +m.week
                            return m
                          }),
                        ageGroupsHosp,
                        'v'
                      ) || 1

                    return (
                      <div className='agegroup' key={'agegroup_cases_' + i}>
                        <div className='age'>{m}</div>
                        <div className='barcontainer'>
                          <Area
                            data={[ad]}
                            yDomain={[max, 0]}
                            yTicks={{
                              lines: [0],
                              text: []
                            }}
                            height={60}
                            xTicks={{
                              text: [
                                '2020-01-01',
                                '2021-01-01',
                                '2021-07-01',
                                '2021-12-01'
                              ],
                              lines: [
                                '2020-01-01',
                                '2021-01-01',
                                '2021-07-01',
                                '2021-12-01'
                              ]
                            }}
                            className='hospAge'
                          />
                        </div>
                        <div className='value'>
                          {Math.round(od[od.length - 1].v)}
                        </div>
                      </div>
                    )
                  })}
                </Chart>
              )}
            </div>
          </div>
        </div>
      </div>{' '}
      <div className='ui container'>
        <div className='columnwrapper'>
          <div className='left'>
            <div className='Ages'>
              {testAgeData && (
                <Chart
                  title='Anzahl Tests pro Woche im Kt. Zürich'
                  sub={`bis zum ${formatSwissDate(
                    testAgeData[testAgeData.length - 1].d
                  )}`}
                  source={
                    <>
                      Quelle:{' '}
                      <a
                        href='https://raw.githubusercontent.com/openZH/covid_19/master/fallzahlen_kanton_zh/COVID19_Anteil_positiver_Test_Alterklassen_pro_KW.csv'
                        target='_blank'
                        rel='noreferrer'
                      >
                        Gesundheitsdirektion Kanton Zürich
                      </a>
                    </>
                  }
                >
                  <div className='agekey'>
                    <div className='left'>Altersgruppe</div>
                    <div className='middle' />
                    <div className='value'>aktuell</div>
                  </div>
                  {ageGroupsTests.map((m, i) => {
                    const od = testAgeData.filter(f => f.age === m)
                    const ad = od.map(m => ({ d: m.d, v: m.v }))
                    if (od.length === 0) return null
                    const max =
                      getMaxValue(testAgeData, ageGroupsTests, 'v') || 1
                    return (
                      <div className='agegroup' key={'agegroup_tests_' + i}>
                        <div className='age'>{m}</div>
                        <div className='barcontainer'>
                          <Area
                            data={[ad]}
                            yDomain={[max * 4, 0]}
                            yTicks={{
                              lines: [0],
                              text: []
                            }}
                            height={60}
                            xTicks={{
                              text: [
                                '2020-01-01',
                                '2021-01-01',
                                '2021-07-01',
                                '2021-12-01'
                              ],
                              lines: [
                                '2020-01-01',
                                '2021-01-01',
                                '2021-07-01',
                                '2021-12-01'
                              ]
                            }}
                            className='TestInz'
                          />
                        </div>
                        <div className='value'>
                          {od[od.length - 1] && Math.round(od[od.length - 1].v)}
                        </div>
                      </div>
                    )
                  })}
                </Chart>
              )}
            </div>
          </div>
          <div className='right'>
            <div className='Ages'>
              {testAgeData && (
                <Chart
                  title='Anzahl positive Tests pro Woche im Kt. Zürich'
                  sub={`bis zum ${formatSwissDate(
                    testAgeData[testAgeData.length - 1].d
                  )}`}
                  source={
                    <>
                      Quelle:{' '}
                      <a
                        href='https://raw.githubusercontent.com/openZH/covid_19/master/fallzahlen_kanton_zh/COVID19_Anteil_positiver_Test_Alterklassen_pro_KW.csv'
                        target='_blank'
                        rel='noreferrer'
                      >
                        Gesundheitsdirektion Kanton Zürich
                      </a>
                    </>
                  }
                >
                  <div className='agekey'>
                    <div className='left'>Altersgruppe</div>
                    <div className='middle' />
                    <div className='value'>aktuell</div>
                    <div className='value'>Pos.Rat.</div>
                  </div>
                  {ageGroupsTests.map((m, i) => {
                    const od = testAgeData.filter(f => f.age === m)
                    const ad = od.map(m => ({ d: m.d, v: m.vPos }))
                    if (od.length === 0) return null
                    const max =
                      getMaxValue(testAgeData, ageGroupsTests, 'vPos') || 1
                    return (
                      <div className='agegroup' key={'agegroup_postests_' + i}>
                        <div className='age'>{m}</div>
                        <div className='barcontainer'>
                          <Area
                            data={[ad]}
                            yDomain={[max * 8, 0]}
                            yProp='vPos'
                            yTicks={{
                              lines: [0],
                              text: []
                            }}
                            height={60}
                            xTicks={{
                              text: [
                                '2020-01-01',
                                '2021-01-01',
                                '2021-07-01',
                                '2021-12-01'
                              ],
                              lines: [
                                '2020-01-01',
                                '2021-01-01',
                                '2021-07-01',
                                '2021-12-01'
                              ]
                            }}
                            className='TestPosInz'
                          />
                        </div>
                        <div className='value'>
                          {Math.round(od[od.length - 1].vPos)}
                        </div>
                        <div className='value rate'>
                          {od[od.length - 1].sharePos.toFixed(1) + '%'}
                        </div>
                      </div>
                    )
                  })}
                </Chart>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className='ui container'>
        <div className='columnwrapper'>
          <div className='left'>
            <div className='Ages'>
              {ageVaccData && (
                <Chart
                  title='Impfquote im Kt. Zürich'
                  sub={`Anteil der mindestens einmal geimpften Personen, bis zum ${formatSwissDate(
                    ageVaccData[ageVaccData.length - 1].d
                  )}`}
                  source={
                    <>
                      Quelle:{' '}
                      <a
                        href='https://github.com/openZH/covid_19_vaccination_campaign_ZH'
                        target='_blank'
                        rel='noreferrer'
                      >
                        Gesundheitsdirektion Kanton Zürich
                      </a>
                    </>
                  }
                >
                  {' '}
                  <div className='agekey'>
                    <div className='left'>Altersgruppe</div>
                    <div className='middle' />
                    <div className='value'>aktuell</div>
                  </div>
                  {ageVaccGroupsCases.map((m, i) => {
                    const od = ageVaccData.filter(f => f.age === m)

                    return (
                      <div className='agegroup' key={'agegroup_vacc_' + i}>
                        <div className='age'>{m}</div>
                        <div className='barcontainer'>
                          <Area
                            data={[
                              od.map(m => ({ d: m.d, v: m.firstPerPop })),
                              od.map(m => ({ d: m.d, v: m.secondPerPop })),
                              od.map(m => ({ d: m.d, v: m.thirdPerPop }))

                              // fu.map(m => ({ d: m.d, v: m.sumPercent }))
                            ]}
                            yDomain={[100, 0]}
                            yTicks={{
                              lines: [0],
                              text: []
                            }}
                            height={60}
                            xTicks={{
                              text: [
                                '2020-01-01',
                                '2021-01-01',
                                '2021-07-01',
                                '2021-12-01'
                              ],
                              lines: [
                                '2020-01-01',
                                '2021-01-01',
                                '2021-07-01',
                                '2021-12-01'
                              ]
                            }}
                            className='vacc'
                          />
                        </div>
                        <div className='value'>
                          {od && nF(+od[od.length - 1].firstPerPop.toFixed(1))}%
                        </div>
                      </div>
                    )
                  })}
                  <Key
                    entries={[
                      {
                        type: 'shape',
                        label: 'einfach geimpft',
                        color: '#95D0CF'
                      },
                      {
                        type: 'shape',
                        label: 'doppelt geimpft',
                        color: '#2CA29F'
                      },
                      {
                        type: 'shape',
                        label: 'Booster',
                        color: '#16514F'
                      }
                    ]}
                  />
                </Chart>
              )}
            </div>
            {/* <div className='Ages'>
              {ageVaccData && (
                <Chart
                  title={'Impfquote im Kt. Zürich'}
                  sub={`Anteil der mindestens einmal geimpften Personen, nach Altersgruppen und Wochen, in %, bis zum ${formatSwissDate(
                    ageVaccData[ageVaccData.length - 1].d
                  )}`}
                  source={
                    <>
                      Quelle:{' '}
                      <a
                        href='https://www.covid19.admin.ch/de/vaccination/persons'
                        target='_blank'
                      >
                        BAG
                      </a>
                    </>
                  }
                >
                  {' '}
                  <div className='agekey'>
                    <div className='left'>Altersgruppe</div>
                    <div className='middle' />
                    <div className='value'>aktuell</div>
                  </div>
                  {ageVaccGroupsCases.map((m, i) => {
                    const od = ageVaccDataBAG.filter(
                      f => f.age === m && f.type === 'onedose'
                    )
                    const fu = ageVaccDataBAG.filter(
                      f => f.age === m && f.type === 'fully'
                    )
                    return (
                      <div className='agegroup' key={'agegroup_vacc_' + i}>
                        <div className='age'>{m}</div>
                        <div className='barcontainer'>
                          <Area
                            data={[
                              od.map(m => ({ d: m.d, v: m.sumPercent })),
                              fu.map(m => ({ d: m.d, v: m.sumPercent }))
                            ]}
                            yDomain={[100, 0]}
                            yTicks={{
                              lines: [0],
                              text: []
                            }}
                            height={60}
                            xTicks={{
                              text: [
                                '2020-01-01',
                                '2021-01-01',
                                '2021-07-01',
                                '2021-12-01'
                              ],
                              lines: [
                                '2020-01-01',
                                '2021-01-01',
                                '2021-07-01',
                                '2021-12-01'
                              ]
                            }}
                            className='vacc'
                          />
                        </div>
                        <div className='value'>
                          {od && nF(+od[od.length - 1].sumPercent.toFixed(1))}%
                        </div>
                      </div>
                    )
                  })}
                  <Key
                    entries={[
                      {
                        type: 'shape',
                        label: 'einfach geimpft',
                        color: '#2ca29f'
                      },
                      {
                        type: 'shape',
                        label: 'doppelt geimpft',
                        color: '#16514f'
                      }
                    ]}
                  />
                </Chart>
              )}
            </div> */}
          </div>

          <div className='right' />
        </div>
      </div>
    </>
  )
}
